import { PosPlugin } from 'plugins/plugin';

import infoMDUrl from './documentation.md';

export const TgfPluginMeta: Pick<PosPlugin, 'id' | 'name' | 'infoMDUrl'> = {
  id: 'tgf-customizations',
  name: 'TGF Customizations',
  infoMDUrl,
};
